<span id="post-download-popup-wrapper">
  <span id="post-download-popup-content"><h2>Your export is downloading!</h2>
    <span id="download-popup-text">Please allow up to 5 minutes for your zip file to be <br> downloaded. You may exit
        this page and continue <br>working within CPSC Analytics.</span>
    <div id="post-download-button-wrapper">
      <button id="close-post-download-popup" mat-raised-button (click)="closePostDownloadPopup()">Ok</button>
    </div>
  </span>
</span>
